import type { CmtsDependencyError } from "@cmts/errors/index.js";
import { SwotAlert, SwotBlockingDialog } from "@swot-shared/feedback/index.js";

export type DependencyErrorsProps = {
  readonly errors: readonly CmtsDependencyError[];
  readonly mode?: "panel" | "dialog" | "inline" | undefined;
  readonly onClose?: (() => void) | undefined;
};

export function DependencyErrors(props: DependencyErrorsProps) {
  const dependencyErrors = props.errors;
  const errors = dependencyErrors.filter((item) => item.blocking || item.reason.trim().length > 0);
  if (errors.length === 0) return null;
  const body = <DependencyList errors={errors} />;
  if (props.mode === "dialog") {
    return <SwotBlockingDialog title="Action blocked by dependencies" onClose={props.onClose}>{body}</SwotBlockingDialog>;
  }
  if (props.mode === "inline") {
    return <div className="cmts-dependency-errors cmts-dependency-errors--inline">{body}</div>;
  }
  return (
    <SwotAlert tone="error" title="Action blocked by dependencies" className="cmts-dependency-errors">
      <p>Resolve the blocking dependent records before continuing. Destructive confirmation must remain disabled while these dependencies exist.</p>
      {body}
    </SwotAlert>
  );
}

function DependencyList(props: { readonly errors: readonly CmtsDependencyError[] }) {
  return (
    <ul className="cmts-dependency-errors__list">
      {props.errors.map((dependency, index) => (
        <li key={`${dependency.entityType}-${dependency.entityId ?? dependency.displayName ?? dependency.reason}-${index}`}>
          <strong>{dependency.entityType}</strong>
          {dependency.displayName ? <> — {dependency.displayName}</> : null}
          {dependency.entityId ? <> <span>({dependency.entityId})</span></> : null}
          {dependency.count !== undefined ? <> <span>Count: {dependency.count}</span></> : null}
          <p>{dependency.reason}</p>
        </li>
      ))}
    </ul>
  );
}
